import { Backdrop } from "@mui/material";
import { BounceLoader } from "react-spinners";

const Spinner = ({ isLoading }: any) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <BounceLoader color="#FA0" loading={isLoading} />
    </Backdrop>
  );
};

export default Spinner;
